import React from "react";
import {IProduct} from 'data/interfaces/products';
import AdInfo from 'gui/pages/mainRouter/pages/ad/components/commons/adInfo';
import HotelInfo
  from 'gui/pages/mainRouter/pages/ad/components/adHotel/components/firstStage/components/hotelDetailsCard/components/hotelInfo';
import FlightInfo
  from 'gui/pages/mainRouter/pages/ad/components/adFlight/components/firstStage/components/flightInfo/FlightInfo';


export interface IHotelInfoProps {
  product: IProduct;
  className?: string;
  title?: string;
  hideTitle?: boolean;
  additionalDetails?: any;
}

const VacationInfo = (props: IHotelInfoProps) => (
  <AdInfo {...props}>
    <FlightInfo {...props} hideTitle/>
    <HotelInfo {...props} hideTitle/>
  </AdInfo>
);

VacationInfo.defaultProps = {
  product: {},
  title: 'מידע:',
  className: '',
  additionalDetails: null,
};

export default VacationInfo;
